import { Link } from "react-router-dom";

const primaryClasses =
    "inline-flex items-center justify-center gap-2 bg-wine text-white px-8 py-3 uppercase tracking-[0.2em] text-xs font-semibold hover:bg-wine-deep transition-colors duration-300";
const secondaryClasses =
    "inline-flex items-center justify-center gap-2 bg-transparent border border-wine/40 text-wine px-8 py-3 uppercase tracking-[0.2em] text-xs font-semibold hover:bg-wine/5 hover:border-wine transition-colors duration-300";

export function ButtonPrimary({ to, children, className = "", ...props }) {
    if (to) {
        return (
            <Link to={to} className={`${primaryClasses} ${className}`} {...props}>
                {children}
            </Link>
        );
    }
    return (
        <button className={`${primaryClasses} ${className}`} {...props}>
            {children}
        </button>
    );
}

export function ButtonSecondary({ to, children, className = "", ...props }) {
    if (to) {
        return (
            <Link to={to} className={`${secondaryClasses} ${className}`} {...props}>
                {children}
            </Link>
        );
    }
    return (
        <button className={`${secondaryClasses} ${className}`} {...props}>
            {children}
        </button>
    );
}
